import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.scss";
import Home from "./pages/home/home.jsx";
import ScrollToTop from "./component/ScrollToTop/ScrollToTop.jsx";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Navbar from "./component/navbar/navbar.jsx";
import Footer from "./component/footer/footer.jsx";
import Testimonial from "./component/testimonial/testimonial";
import Penawaranbalik from "./component/penawaranbalik/penawaranbalik";
import Residentials from "./pages/category/residential/residentials.jsx";
import Commercials from "./pages/category/commercial/commercial.jsx";
import Cherryville from "./pages/detail/cherryville/cherryville.jsx";
import Waterterrace from "./pages/detail/waterterrace/waterterrace.jsx";
import O8 from "./pages/detail/o8/o8.jsx";
import Vicente from "./pages/detail/vicente/vicente.jsx";
import Levante from "./pages/detail/levante/levante.jsx";
import Thekaia from "./pages/detail/thekaia/thekaia.jsx";
import Zliving from "./pages/detail/zliving/zliving.jsx";
import Tanamas from "./pages/detail/tanamas/tanamas.jsx";
import Grandlemonade from "./pages/detail/grandlemonade/grandlemonade.jsx";
import Gardenloft from "./pages/detail/gardenloft/gardenloft.jsx";
import Giva from "./pages/detail/giva/giva.jsx";
import Altara from "./pages/detail/altara/altara.jsx";

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/residentials/" element={<Residentials />} />
          <Route path="/commercials/" element={<Commercials />} />
          <Route path="/cherryville/" element={<Cherryville />} />
          <Route path="/waterterrace/" element={<Waterterrace />} />
          <Route path="/o8/" element={<O8 />} />
          <Route path="/vicente/" element={<Vicente />} />
          <Route path="/levante/" element={<Levante />} />
          <Route path="/zliving/" element={<Zliving />} />
          <Route path="/gardenloft/" element={<Gardenloft />} />
          <Route path="/grandlemonade/" element={<Grandlemonade />} />
          <Route path="/tanamas/" element={<Tanamas />} />
          <Route path="/yara/" element={<Thekaia />} />
          <Route path="/giva/" element={<Giva />} />
          <Route path="/altara/" element={<Altara />} />
        </Routes>
        <a href="https://api.whatsapp.com/send?phone=62895417144022&text=Halo%20Sandy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20()%20(https://marketing-grandwisatabekasi.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0">
          <FloatingWhatsApp />
        </a>
        <Testimonial />
        <Penawaranbalik />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
